import TVChartContainerHook from 'components/common/TradingView/chart/TVChartContainerHook';
// import TradingViewV2 from 'components/common/TradingView/TradingView';
import { useSelector } from 'react-redux';
import './Overview.scss';
import NumberTrading from './OverView/NumberTrading';
import NumberTrading2 from './OverView/NumberTrading2';

export default function Overview() {
  const AStore = useSelector((state) => state?.AStore)

  return (
    <>
      <div className='UHrbfiJYjz'>
        <div className='DHjBaGZNUE'>
          <TVChartContainerHook />
        </div>
        <div className='cedzxyqqjb'>
          <NumberTrading data={AStore?.Overview} />
          <NumberTrading2 data={AStore?.Overview} />
        </div>
      </div>
    </>
  )
}